// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__TSmtS {
  margin-bottom: 1rem; }

.styles_contentContainer__0C0cD {
  height: 54vh;
  overflow-y: scroll; }
`, "",{"version":3,"sources":["webpack://./src/modules/timetracker/components/DedicateTimeForm/styles.module.scss"],"names":[],"mappings":"AAEA;EACI,mBAAmB,EAAA;;AAGvB;EACI,YAAY;EACZ,kBAAkB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.container {\n    margin-bottom: 1rem;\n}\n\n.contentContainer {\n    height: 54vh;\n    overflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__TSmtS`,
	"contentContainer": `styles_contentContainer__0C0cD`
};
export default ___CSS_LOADER_EXPORT___;
